const creditCardExpiration = /(\d{2})\/(\d{2})/;

export default creditCardExpiration;
